// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"86c49042","141":"25dfee16","305":"efe387d9","385":"e8994d96","436":"01b064d7","496":"86c49042"}[chunkId] + ".chunk.css";
};